import moment from 'moment';
import { useTranslation } from 'react-i18next';

import withModalView from 'components/ui/withModalView';
import withContentLoader from 'components/ui/withContentLoader';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';
import NotFound from 'components/ui/NotFound';

import JobApi from 'api/job';

const JobDetailsPage = ({ data }) => {
  const { t } = useTranslation();

  if (!data) {
    return <NotFound />;
  }

  const { bot, input_data } = data;

  const input_data_config = bot.schemas.find(item => item.id === 'input_data') || {};
  const { schema = {} } = input_data_config;
  const props = schema.properties || {};

  const renderPayload = () => {
    const data = [];

    for (const prop of Object.keys(props)) {
      const item = props[prop] || {};
      data.push(
        <tr key={prop}>
          <th>{item.title}:</th>
          <td>{getPayloadProp(prop, item)}</td>
        </tr>
      );
    }

    return data;
  };

  const getPayloadProp = (prop, item) => {
    const value = input_data[prop];
    if (['date', 'datetime'].includes(item.format)) {
      return formatDate(value);
    }
    return value || '--';
  };

  const formatDate = date => {
    if (!date) {
      return '--';
    }
    return moment(date).format(t('formats.datetime'));
  };

  const formatError = data => {
    const data_error = data || {};
    const error = data_error.error || {};
    return error.message || data_error.message || t('keys.unknown');
  };

  const renderError = () => {
    if (data.status !== 'FAILED') {
      return null;
    }
    return (
      <tr>
        <th>{t('columns.failed_reason')}:</th>
        <td>{formatError(data.error)}</td>
      </tr>
    );
  };

  return (
    <>
      <div className="container">
        <div className="mb-2">{t('bots.jobs.details.title')}</div>
        <h3>{data.bot.name}</h3>

        <table className="mt-4 table table-bordered border-primary">
          <tbody>
            <tr>
              <th>ID:</th>
              <td>{data.id}</td>
            </tr>

            <tr>
              <th>{t('columns.title')}:</th>
              <td>{data.title}</td>
            </tr>

            {renderPayload()}

            <tr>
              <th>{t('columns.created_at')}:</th>
              <td>{formatDate(data.created_at || data.createdAt)}</td>
            </tr>

            <tr>
              <th>{t('columns.start_at')}:</th>
              <td>{formatDate(data.start_at)}</td>
            </tr>

            <tr>
              <th>{t('columns.started_at')}:</th>
              <td>{formatDate(data.started_at)}</td>
            </tr>

            <tr>
              <th>{t('columns.done_at')}:</th>
              <td>{formatDate(data.done_at)}</td>
            </tr>

            <tr>
              <th>{t('columns.status')}:</th>
              <td>{t(`status.${data.status.toLowerCase()}`)}</td>
            </tr>

            <tr>
              <th>{t('columns.device')}:</th>
              <td>{data?.device?.name || '-'}</td>
            </tr>

            <tr>
              <th>{t('columns.device')} ID:</th>
              <td>{data.device_id}</td>
            </tr>

            {renderError()}
          </tbody>
        </table>
      </div>
    </>
  );
};

const fetchData = async ({ routeMatch }) => {
  const { params } = routeMatch;
  return await JobApi.get(params.jobId);
};

const page = withContentLoader(JobDetailsPage, { name: 'job-details', fetchData });
export default withModalView(withAuthorizer(page, [Resources.BOT_MANAGER]));
